import { render, staticRenderFns } from "./desk-global.vue?vue&type=template&id=24901978&scoped=true&"
import script from "./desk-global.vue?vue&type=script&lang=js&"
export * from "./desk-global.vue?vue&type=script&lang=js&"
import style0 from "./desk-global.vue?vue&type=style&index=0&id=24901978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24901978",
  null
  
)

export default component.exports